import { PcodeAds } from '../../../typings/pcode';
import { CanvasApiBaseResponse, VIDEO_ADDITIONS_URL } from '../../common/requestsTypings';
import { DEFAULT_FETCH_LIMIT, SharedData } from '../../common/typings';
import {
    GetCampaignsResponse,
    GetVideoAdditionsResponse,
    VastInfo,
    VideoCreativeListItem
} from '../../VideoCreatives/typings';

import { CreativesApiMethodExecutor } from './CreativesApiMethodExecutor';

const PATH = `${VIDEO_ADDITIONS_URL}/additions`;

export class VideoCreativesApiMethodExecutor extends CreativesApiMethodExecutor {
    constructor() {
        super(PATH);
    }

    async getCreatives(offset: number, text: string, showTied: boolean, sharedData: SharedData) {
        const queryParams = [
            'part=' + text || '',
            'sort_order=desc',
            'sort_by=date',
            `limit=${DEFAULT_FETCH_LIMIT}`,
            `offset=${offset}`
        ];
        if (showTied) {
            queryParams.push('filters=campaign_tied');
        }

        return this.createRequest<GetVideoAdditionsResponse>(
            PATH,
            {
                method: 'GET'
            },
            sharedData,
            queryParams
        );
    }

    async getCampaigns(id: string, sharedData: SharedData) {
        return await this.createRequest<GetCampaignsResponse>(
            `${PATH}/${id}/campaigns`,
            {
                method: 'GET'
            },
            sharedData
        );
    }

    async submit(items: VideoCreativeListItem[], sharedData: SharedData): Promise<CanvasApiBaseResponse> {
        return await this.createRequest<CanvasApiBaseResponse>(
            `${VIDEO_ADDITIONS_URL}/direct/additions`,
            {
                method: 'POST',
                body: JSON.stringify({
                    additions: items.map(item => ({ id: item.id }))
                })
            },
            sharedData
        );
    }

    async getVast(id: string, previewData: PcodeAds, sharedData: SharedData) {
        return await this.createRequest<VastInfo>(
            `${PATH}/${id}/preview`,
            {
                method: 'POST',
                body: JSON.stringify({
                    previewData
                })
            },
            sharedData
        );
    }
}
